module.exports = __webpack_public_path__ + "static/movieFlowPhone-b7f9e2345ea053d9a54ce7c4ac5566fe.svg";